module.exports = {"casino":{"nouvelle_demande":"New application","continuer_la_demande":"Continue application","mon_compte":"My account","se_connecter":"Log in","s_inscrire":"Register","accueil":"Home","mes_produits":"My products","mes_dossiers":"My folders","mes_demandes":"My requests","notifications":"Notifications","parametres":"Settings","deconnexion":"Logout"}}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/en/template/menu.lang.json
// module id = g+5H
// module chunks = 1